import roles from "../constants/roles"


// Admin pages are lazy-loaded so the whole admin bundle (tinymce, mapbox-gl,
// file uploads, exports, ...) stays out of the public site's initial download.
const DashboardLayout = () => import("../layout/dashboard/DashboardLayout.vue")
const Welcome = () => import("../pages/admin/Welcome.vue")
const Dashboard = () => import("../pages/admin/Dashboard.vue")
const Properties = () => import("../pages/admin/Properties.vue")
const Payments = () => import("../pages/admin/Payments.vue")
const Orders = () => import("../pages/admin/Orders")
const SellTokenRequests = () => import("../pages/admin/SellTokenRequests")
const Waitlist = () => import("../pages/admin/Waitlist")
const Config = () => import("../pages/admin/Config")
const Role = () => import("../pages/admin/Role")
const AdminUser = () => import("../pages/admin/AdminUser")
const Referral = () => import("../pages/admin/Referral")
const Location = () => import("../pages/admin/Location")
const Category = () => import("../pages/admin/Category")
const Withdrawal = () => import("../pages/admin/Withdrawal")
const BankAccountManagement = () => import("../pages/admin/BankAccountManagement")
const EmailTemplate = () => import("../pages/admin/EmailTemplate")
const Email = () => import("../pages/admin/Email")
const EmailBroadcast = () => import("../pages/admin/EmailBroadcast")
const User = () => import("../pages/admin/User")
const RentalDistributions = () => import("../pages/admin/rental-distribution/RentalDistributions.vue")
const RentalDistributionDetails = () => import("../pages/admin/rental-distribution/RentalDistributionDetails.vue")
const RentalDeductionTypes = () => import("../pages/admin/rental-distribution/RentalDeductionTypes.vue")
const Banner = () => import("../pages/admin/Banner")
const DonationBanner = () => import("../pages/admin/DonationBanner")
const DonationTransaction = () => import("../pages/admin/DonationTransaction")
const VirtualRentalDistributionDetails = () => import("../pages/admin/VirtualRentalDistributionDetails")
const ContractTemplates = () => import("../pages/admin/ContractTemplates.vue")
const Spcs = () => import("../pages/admin/Spcs")
const PropertyDashboard = () => import("../pages/admin/PropertyDashboard.vue")
const TwoFactorAuth = () => import("../pages/admin/TwoFactorAuth.vue")
const StatisticNumbers = () => import("../pages/admin/StatisticNumbers")
const RmDashboard = () => import("../pages/admin/RmDashboard.vue")
const Maintenance = () => import("../pages/admin/Maintenance.vue")
const AdminLogsDashboard = () => import("../pages/admin/AdminLogsDashboard.vue")
const Partner = () => import("../pages/admin/Partner")
const VideoPlaylist = () => import("../pages/admin/VideoPlaylist.vue")
const Video = () => import("../pages/admin/Video.vue")
const Voucher = () => import("../pages/admin/voucher/Voucher.vue");
const VoucherCode = () => import("../pages/admin/voucher/VoucherCode.vue");
const VoucherTag = () => import("../pages/admin/voucher/VoucherTag.vue");
const VoucherRedemption = () => import("../pages/admin/voucher/VoucherRedemption.vue");
const Reward = () => import("../pages/admin/reward/Reward.vue");
const RewardCode = () => import("../pages/admin/reward/RewardCode.vue");
const RewardTag = () => import("../pages/admin/reward/RewardTag.vue");
const RewardRedemption = () => import("../pages/admin/reward/RewardRedemption.vue");
const DocumentVersioning = () => import("../pages/admin/DocumentVersioning.vue")
const AttestationReport = () => import("../pages/admin/AttestationReport.vue")
const Event = () => import("../pages/admin/Event.vue")
const PreRegisteredUser = () => import("../pages/admin/PreRegisteredUser.vue")
const BondListings = () => import("../pages/admin/BondListings.vue")
const BalanceHistory = () => import("../pages/admin/BalanceHistory.vue")
const BalanceRequests = () => import("../pages/admin/BalanceRequests.vue")
const TokenRequests = () => import("../pages/admin/TokenRequests.vue")
const FeeReport = () => import("../pages/admin/FeeReport.vue")

const admin = [
  {
    path: "/goroadmin",
    component: DashboardLayout,
    redirect: "/goroadmin/welcome",
    name: "goroadmin",
    meta: {
      authorize: [roles.Admin],
    },
    children: [
      {
        path: "welcome",
        name: "adminWelcome",
        component: Welcome,
      },
      {
        path: "dashboard",
        name: "adminDashboard",
        component: Dashboard,
      },
      {
        path: "token-transaction-dashboard",
        name: "tokenTransactionDashboard",
        component: PropertyDashboard,
      },
      {
        path: "balance-history",
        name: "adminBalanceHistory",
        component: BalanceHistory,
      },
      {
        path: "balance-requests",
        name: "adminBalanceRequests",
        component: BalanceRequests,
      },
      {
        path: "token-requests",
        name: "adminTokenRequests",
        component: TokenRequests,
      },
      {
        path: "properties",
        name: "adminProperties",
        component: Properties
      },
      {
        path: "bond-listings",
        name: "adminBondListings",
        component: BondListings
      },
      {
        path: "payments",
        name: "adminPayments",
        component: Payments
      },
      {
        path: "orders",
        name: "adminOrders",
        component: Orders
      },
      {
        path: "sell-token-request",
        name: "adminSellTokenRequests",
        component: SellTokenRequests
      },
      {
        path: "contractTemplates",
        name: "adminContractTemplates",
        component: ContractTemplates
      },
      {
        path: "waitlists",
        name: "adminWaitlists",
        component: Waitlist
      },
      {
        path: "configs",
        name: "adminConfigs",
        component: Config
      },
      {
        path: "roles",
        name: "adminRoles",
        component: Role
      },
      {
        path: "admin-users",
        name: "adminAdminUsers",
        component: AdminUser
      },
      {
        path: "partners",
        name: "adminPartner",
        component: Partner
      },
      {
        path: "referrals",
        name: "adminReferrals",
        component: Referral
      },
      {
        path: "spcs",
        name: "adminSpcs",
        component: Spcs
      },
      {
        path: "locations",
        name: "adminLocations",
        component: Location
      },
      {
        path: "categories",
        name: "adminCategories",
        component: Category
      },
      {
        path: "users",
        name: "adminUsers",
        component: User
      },
      {
        path: "withdrawals",
        name: "adminWithdrawals",
        component: Withdrawal
      },
      {
        path: "bank-accounts",
        name: "adminBankAccounts",
        component: BankAccountManagement
      },
      {
        path: "email-templates",
        name: "emailTemplates",
        component: EmailTemplate
      },
      {
        path: "emails",
        name: "emails",
        component: Email
      },
      {
        path: "email-broadcast",
        name: "emailBroadcast",
        component: EmailBroadcast
      },
      {
        path: "rentalDistributions",
        name: "adminRentalDistributions",
        component: RentalDistributions
      },
      {
        path: "rentalDistributionDetails",
        name: "adminRentalDistributionDetails",
        component: RentalDistributionDetails
      },
      {
        path: "virtual-rental-distribution-details",
        name: "adminVirtualRentalDistributionDetails",
        component: VirtualRentalDistributionDetails
      },
      {
        path: "rentalDeductionTypes",
        name: "adminRentalDeductionTypes",
        component: RentalDeductionTypes
      },
      {
        path: 'banners',
        name: 'banners',
        component: Banner,
      },
      {
        path: 'donation-banners',
        name: 'donationBanners',
        component: DonationBanner,
      },
      {
        path: 'donation-transactions',
        name: 'donationTransactions',
        component: DonationTransaction,
      },
      {
        path: 'statistic-numbers',
        name: 'adminStatisticNumbers',
        component: StatisticNumbers,
      },
      {
        path: 'twofa',
        name: 'twofa',
        component: TwoFactorAuth,
      },
      {
        path: 'rm-dashboard',
        name: 'rmDashboard',
        component: RmDashboard,
      },
      {
        path: 'maintenance',
        name: 'maintenance',
        component: Maintenance,
      },
      {
        path: "admin-logs",
        name: "adminLogsDashboard",
        component: AdminLogsDashboard,
      },
      {
        path: 'video-playlists',
        name: 'videoPlaylists',
        component: VideoPlaylist,
      },
      {
        path: 'videos',
        name: 'videos',
        component: Video,
      },
      {
        path: 'vouchers',
        name: 'adminVouchers',
        component: Voucher,
      },
      {
        path: 'voucher-code',
        name: 'adminVoucherCodes',
        component: VoucherCode,
      },
      {
        path: 'voucher-tag',
        name: 'adminVoucherTags',
        component: VoucherTag,
      },
      {
        path: 'voucher-redemption',
        name: 'adminVoucherRedemptions',
        component: VoucherRedemption,
      },
      {
        path: 'rewards',
        name: 'adminRewards',
        component: Reward,
      },
      {
        path: 'reward-code',
        name: 'adminRewardCodes',
        component: RewardCode,
      },
      {
        path: 'reward-tag',
        name: 'adminRewardTags',
        component: RewardTag,
      },
      {
        path: 'reward-redemption',
        name: 'adminRewardRedemptions',
        component: RewardRedemption,
      },
      {
        path: 'document-versioning',
        name: 'documentVersioning',
        component: DocumentVersioning,
      },
      {
        path: 'attestation-reports',
        name: 'attestationReports',
        component: AttestationReport,
      },
      {
        path: 'admin-events',
        name: 'adminEvents',
        component: Event,
      },
      {
        path: "pre-registered-users",
        name: "preRegisteredUsers",
        component: PreRegisteredUser
      },
      {
        path: "reports/fee-revenue",
        name: "adminFeeRevenueReport",
        component: FeeReport
      },
    ]
  }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default admin
